import { useEffect, useRef, useState } from 'react';
import bem from '../../../utils/bem';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';

import Icon from '../../Atoms/Icon/Icon';
import ModalComponent from '../../Molecules/Modal';
import ContractorsModalContent from './ContractorsModalContent';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import {
  openModalHandler,
  closeModalHandler,
} from '../../../utils/handleModalActions';

const ContractorTray = ({
  contractors = [],
  className,
  onRemove,
  estimateLink,
  offsetSelectors,
  contratorAddLink,
  setTray = () => {},
}) => {
  const selfRef = useRef(null);
  const [positionOffset, setPositionOffset] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (window) {
      const offsetElements = document.querySelectorAll(offsetSelectors);
      if (offsetElements.length) {
        let offset = 0;
        offsetElements.forEach(function (el) {
          offset += el.offsetHeight;
        });
        setPositionOffset(offset);
      }
    }
  }, [offsetSelectors]);
  const entry = useIntersectionObserver(selfRef, {
    rootMargin: `-${positionOffset}px`,
  });
  const componentBaseClass = 'o-contractor-tray';
  const addStickyClass = (t) => {
    if (
      !t.isIntersecting &&
      t.boundingClientRect.y < t.rootBounds.y &&
      t.intersectionRatio >= 0 &&
      t.intersectionRatio < 1
    ) {
      return 'is--sticky';
    }
    return '';
  };

  const contractorPlurals =
    contractors.length === 1 ? Drupal.t('Contractor') : Drupal.t('Contractors');
  const titleMsg = Drupal.t('Get an Estimate');
  const titleSubtle = Drupal.t('Added');
  const contractorModalId = 'contractors-tray-modal';
  const pushAnalyticEvent = useAnalyticsPushEvent();

  const openModal = (e) =>
    openModalHandler(e, 'contractors-tray-opened', () => {
      // Push data to dataLayer
      pushAnalyticEvent({
        event: 'estimate_tray_opened',
        event_origin: 'front_end',
      });
    });

  const closeModal = (e) => closeModalHandler(e, 'contractors-tray-opened');

  useEffect(() => {
    let timeOut;
    if (contractors.length > 0 && window) {
      setAnimate(true);
      timeOut = setTimeout(() => {
        setAnimate(false);
      }, 600);
      setTray(true);
    } else {
      setTray(false);
    }
    return () => clearTimeout(timeOut);
  }, [contractors]);

  return (
    <div
      ref={selfRef}
      className={bem(componentBaseClass, [], '', [
        entry && addStickyClass(entry),
        className,
        contractors.length < 1 ? 'is-empty' : '',
        animate && 'animate',
      ])}
    >
      <button
        type="button"
        className={bem('button', [], componentBaseClass)}
        data-modal-id={contractorModalId}
        style={{ top: positionOffset }}
        onClick={(e) => openModal(e)}
      >
        <span className={bem('title', [], componentBaseClass)}>
          {titleMsg}&nbsp;
          <br />
          {`(${contractors.length} ${contractorPlurals} ${titleSubtle})`}
          <span className={'icon-wrapper block'}>
            <Icon
              iconName="expand-bottom"
              width={9}
              height={9}
              style={{ pointerEvents: 'none' }}
              className={'icon-bottom'}
            />
            <Icon
              iconName="expand-top"
              width={9}
              height={9}
              style={{ pointerEvents: 'none' }}
              className={'icon-top'}
            />
          </span>
        </span>
      </button>
      <ModalComponent
        modal_id={contractorModalId}
        modal_modifiers={['variant-classic']}
        onCloseHandler={(e) => closeModal(e)}
        children={
          <ContractorsModalContent
            className={bem('modal-content', [], componentBaseClass)}
            contractors={contractors}
            onRemove={(id) => onRemove(id)}
            estimateLink={estimateLink}
            contratorAddLink={contratorAddLink}
          />
        }
      />
    </div>
  );
};

export default ContractorTray;
